export const CURRENCIES = [
  { code: "USD", symbol: "$", name: "Доллар", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "EUR", symbol: "\u20AC", name: "Евро", flag: "\u{1F1EA}\u{1F1FA}" },
  { code: "GBP", symbol: "\u00A3", name: "Фунт", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "TRY", symbol: "\u20BA", name: "Лира", flag: "\u{1F1F9}\u{1F1F7}" },
  { code: "RUB", symbol: "\u20BD", name: "Рубль", flag: "\u{1F1F7}\u{1F1FA}" },
  { code: "UAH", symbol: "\u20B4", name: "Гривна", flag: "\u{1F1FA}\u{1F1E6}" },
  { code: "KZT", symbol: "\u20B8", name: "Тенге", flag: "\u{1F1F0}\u{1F1FF}" },
  { code: "CHF", symbol: "CHF ", name: "Франк", flag: "\u{1F1E8}\u{1F1ED}" },
  { code: "CZK", symbol: "Kč ", name: "Крона", flag: "\u{1F1E8}\u{1F1FF}" },
];

export const getCurrencyByCode = (code) =>
  CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];

export const convertPrice = (price, baseCurrency, targetCurrency, rates) => {
  if (!rates || baseCurrency === targetCurrency) return price;
  const rate = rates[baseCurrency]?.[targetCurrency];
  if (!rate) return price;
  return Math.round(price * rate);
};
